import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { useState } from "react";

// Components
import { IcomDropdown, Option } from "src/components/icom-dropdown";
import { setScheduledPause } from "src/store/auth/reducer";
import SidePanel from "./panel";

export default function PanelPrePause({
  togglePanel,
}: {
  togglePanel: Function;
}) {
  const { availablePauseTypes } = useAppSelector((state) => state.context);
  const { scheduledPause } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const [state, setState] = useState<{
    selectedPrePause: string | null;
    submiting: boolean;
  }>({
    selectedPrePause: scheduledPause?.id ?? null,
    submiting: false,
  });

  // Map status to Option pattern
  const listOptions = availablePauseTypes
    .filter((pause) => pause.show)
    .map((s) => ({
      id: s.id,
      label: s.texto,
      value: s.id,
    }));

  // SchedulePauseHandler
  const schedulePause = async () => {
    setState((s) => ({ ...s, submiting: true }));

    const pause = availablePauseTypes.find(
      (p) => p.id === state.selectedPrePause
    );

    dispatch(setScheduledPause(pause));

    await new Promise((resolve) => setTimeout(resolve, 1000));

    setState((s) => ({ ...s, submiting: false }));
  };

  return (
    <SidePanel panelName="Pausa agendada" toggleAction={togglePanel}>
      <div className="flex flex-col justify-between h-full">
        <IcomDropdown
          selectedOption={state.selectedPrePause}
          onChange={(option: Option) =>
            setState((s) => ({ ...s, selectedPrePause: option.value }))
          }
          listOptions={listOptions}
        />

        <button
          disabled={!state.selectedPrePause || state.submiting}
          onClick={() => state.selectedPrePause && schedulePause()}
          className="h-12 bg-primary-blue-400 text-base font-bold text-white flex items-center justify-center rounded-lg hover:bg-primary-blue-500 disabled:bg-gray-300 disabled:text-gray-400"
          type="button"
        >
          {state.submiting ? "Aplicando..." : "Aplicar"}
        </button>
      </div>
    </SidePanel>
  );
}
